import { AboutPage } from "@web/pages/about/AboutPage";
import Head from "next/head";

export default function About() {
  return (
    <>
      <Head>
        <title>Harken | About</title>
      </Head>
      <AboutPage />
    </>
  );
}
